import * as React from 'react'
import { connect } from 'react-redux';
import { passwordReset } from '../../actions/authActions';
import { Redirect } from 'react-router';
import { Form, Button } from 'react-bootstrap';
import { HOME } from '../../routes/routes';
import { Link } from 'react-router-dom';
import { validateEmail } from './../../constants/validation';
import './ForgotPassword.css'
import { logEvent } from '../../firebase/firebase';

class ForgotPassword extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            email: '',
            mailRegex: true,
            submitted: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleChange(e: any) {
        this.setState({ submitted: false });
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    handleClick(e: any) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { email } = this.state;
        if (validateEmail.test(email)) {
            logEvent('SSP_User_Requested_forgot_password', { email });
            this.props.passwordReset(this.state);
        } else {
            this.setState({ mailRegex: false });
        }
    };

    render() {
        const { mailRegex, submitted } = this.state;
        const { auth } = this.props;
        return (
            <div className="ForgotPassword ml-auto mr-auto">
                <h2 className="pb-4">Forgot<br />password</h2>
                <Form.Label className="enter-email-address">Please enter the email you signed up with</Form.Label>
                <Form.Group>
                    <br />
                    <Form.Label className={'left-align temp-text-box-label' + (this.state.email !== "" ? "" : " no-opacity")}>Email</Form.Label>
                    <Form.Control width="324" type="email" placeholder="Email address" id="InputEmail" name="email" value={this.state.email} onChange={this.handleChange} />
                    {submitted && !mailRegex && 
                        <div className="help-block mt-2">A valid email is required</div>
                    }
                </Form.Group>
                <div className="pt-4 pb-2">
                    <Button className="btn btn-solid-red btn-lg" onClick={this.handleClick} id='forgotSubmit'>Send</Button>
                </div> 
                <div className="mt-2">
                    <p>Remembered your password? <Link to={HOME} className="Uh-oh-I-forgot-my-p">Log in</Link></p>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.auth
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        passwordReset: (creds: any) => dispatch(passwordReset(creds))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);